import React from "react";

import styles from "./BtnOptionSelect.module.scss";

/**
 * Component Props
 * @param {children} props
 *
 */

const BtnOptionSelect = (props) => {
  return (
    <button
      {...props}
      className={`${styles.button} ${props.className}`}
    >
      {props.children}
    </button>
  );
};

export default BtnOptionSelect;
